import React, { useState } from "react";
import { adminService } from "../api/services";
import { Mapping } from "../models";

export interface AdminContextProps {
    mappings?: Mapping[];
    getMappings: () => Promise<void>;
    createMapping: (mapping: Mapping) => Promise<void>;
    deleteMapping: (relativeUrl: string) => Promise<void>;
};

export const AdminContext = React.createContext({} as AdminContextProps);

export const AdminStore: React.FC = props => {

    const [mappings, setMappings] = useState<Mapping[]>();

    const onGetMappings = async () => {
        const model = await adminService.getMappings();
        setMappings(model);
    };

    const onCreateMapping = async (mapping: Mapping) => {
        await adminService.createMapping(mapping);
    };

    const onDeleteMapping = async (relativeUrl: string) => {
        await adminService.deleteMapping(relativeUrl);
    };

    return (
        <AdminContext.Provider value={{ mappings: mappings, getMappings: onGetMappings, createMapping: onCreateMapping, deleteMapping: onDeleteMapping }}>
            {props.children}
        </AdminContext.Provider>
    );
};
